module.exports = "/images/cara-philippines.png?1f1808d2f2f29a0ed998ac5024b5ec22";